import {
  TagFragment,
  ResponsiveImage,
  SectionFeaturedProjects,
  SectionLocationMap,
  SectionLocationInfo,
  Video,
  Table
} from '~/graphql/fragments'

export const queryLocation = /* GraphQL */ `
  ${TagFragment}
  ${ResponsiveImage}
  ${Video}
  ${Table}

  ${SectionFeaturedProjects}
  ${SectionLocationMap}
  ${SectionLocationInfo}

  query Location($locale: SiteLocale, $first: IntType = 100, $slug: String) {
    _allLocationsMeta {
      count
    }
    allLocations(first: $first) {
      slug
      title
      imageGallery {
        alt
        url
        width
        height
        title
        responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
          ...ResponsiveImage
        }
      }
    }
    location(locale: $locale, filter: { slug: { eq: $slug } }) {
      _firstPublishedAt
      _publishedAt
      _updatedAt
      _seoMetaTags {
        ...TagFragment
      }
      _allSlugLocales {
        value
        locale
      }
      _allPublishTranslationLocales {
        value
        locale
      }
      __typename
      _modelApiKey
      id
      slug
      title
      imageGallery {
        alt
        url
        width
        height
        title
        responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
          ...ResponsiveImage
        }
      }
      category {
        _modelApiKey
        __typename
        id
        name
        slug
      }
      country {
        _modelApiKey
        __typename
        id
        name
        slug
      }
      elevation
      weather {
        month
        sunnyDays
        highTemperature
        lowTemperature
      }
      html
      metadata
      generalInfo
      blocks {
        __typename
        ...SectionFeaturedProjects
        ...SectionLocationMap
        ...SectionLocationInfo
      }
      publishTranslation
      seoMetadata {
        noIndex
      }
    }
  }
`
